import { render, staticRenderFns } from "./NotSetCard.vue?vue&type=template&id=642827a0&scoped=true&"
import script from "./NotSetCard.vue?vue&type=script&lang=js&"
export * from "./NotSetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642827a0",
  null
  
)

export default component.exports